var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#19A1B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.865 16.5012C12.7772 16.6529 12.6511 16.7788 12.4992 16.8664C12.3474 16.9539 12.1752 17 12 17C11.8248 17 11.6526 16.9539 11.5008 16.8664C11.3489 16.7788 11.2228 16.6529 11.135 16.5012M15 10.2004C15 9.3518 14.684 8.5377 14.1215 7.93762C13.5585 7.33754 12.795 7 12 7C11.2045 7 10.4415 7.33704 9.8785 7.93762C9.316 8.5377 9 9.3518 9 10.2004C9 13.9344 7.5 15.001 7.5 15.001H16.5C16.5 15.001 15 13.9344 15 10.2004Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.c9fecc37fbb4cc351e22ee34c12a67d8.svg";
export { ForwardRef as ReactComponent };